import React from "react";
import { useSelector } from "react-redux";

export default function Button({
    label,
    onClick,
    className,
    labelClassName,
    nextIconClassName,
    backIconClassName,
    ...rest
}) {
    const lang = useSelector((state) => state.translation.lang);
    const flipStyle = {
        transform: lang === "ar" ? "rotate(180deg)" : "none",
    };
    return (
        <button onClick={onClick} className={`${className}`} {...rest}>
            <span className={`${labelClassName}`}>
                {backIconClassName && (
                    <i className={backIconClassName} style={flipStyle}></i>
                )}
                {label}
                {nextIconClassName && (
                    <i className={nextIconClassName} style={flipStyle}></i>
                )}
            </span>
        </button>
    );
}
